import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 저장소 그룹 목록 조회
   * @author leesy918
   * @return {[type]} [description]
   */
  getLogidList() {
    return axios.get(`${baseUrl}/settings/lms-machine/get-logid-list.do`);
  },
  /**
   * 머신 러닝 패턴 데이터 조회
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getMachineLearningList(params) {
    return axios.post(`${baseUrl}/settings/lms-machine/get-machine-learning-list.do`, params);
  },
  /**
   * 머신 러닝 데이터 수정
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateMachineLearning(params) {
    return axios.post(`${baseUrl}/settings/lms-machine/update-machine-learning.do`, params);
  },
  /**
   * 머신러닝 패턴 삭제
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteMachineLearning(params) {
    return axios.post(`${baseUrl}/settings/lms-machine/delete-machine-learning.do`, params);
  },
  /**
   * 패턴 활성화 여부 저장
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  saveActivePatternFlag(params) {
    return axios.post(`${baseUrl}/settings/lms-machine/save-active-pattern-flag.do`, params);
  },
  /**
   * 선택한 머신 러닝 패턴의 원시 로그 조회
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getMlLogList(params) {
    return axios.post(`${baseUrl}/settings/lms-machine/get-ml-log-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/log/lms-machine-learning-setting.js